import { Feature } from '@/pinia/feature'

export const info: Feature = {
  name: 'info',
  enabled: true,
  title: {
    en: 'Information',
    sv: 'Information'
  },
  component: 'FeatureCard',
  isRoute: true,
  props: {
    disableIsDrawPointActive: false,
    enableFullscreen: false,
    icon: 'IconInfoCircle',
    size: 'small',
    subtitle: {
      sv: '',
      en: ''
    }
  },
  children: [
    {
      name: 'info',
      enabled: true,
      title: {
        en: 'Info',
        sv: 'Info'
      },
      children: [
        {
          name: 'general',
          enabled: true,
          title: {
            en: 'Information',
            sv: 'Information'
          },
          component: 'InfoDisplayDashboard',
          isRoute: true,
          props: {},
          children: [
            {
              name: 'overview',
              enabled: true,
              title: {
                en: 'Overview',
                sv: 'Översikt'
              },
              component: 'InfoDisplayOverview',
              props: {
                showForEntityTypes: ['REGION', 'COMPLEX', 'REAL_ESTATE', 'CONSTRUCTION', 'LEVEL']
              }
            },
            {
              name: 'contents',
              enabled: true,
              title: {
                en: 'Contents',
                sv: 'Innehåll'
              },
              component: 'InfoDisplayContentCard',
              props: {
                showForEntityTypes: ['REGION', 'COMPLEX', 'REAL_ESTATE', 'CONSTRUCTION', 'LEVEL'],
                expanded: true
              }
            },
            {
              name: 'apartments',
              enabled: false,
              title: {
                en: 'Apartments',
                sv: 'Lägenheter'
              },
              component: 'InfoDisplayApartmentsCard',
              props: {
                showForEntityTypes: ['CONSTRUCTION'],
                expanded: true
              }
            },
            {
              name: 'indoor-data',
              enabled: true,
              title: {
                en: 'Indoor Data',
                sv: 'Inomhusdata'
              },
              component: 'InfoDisplayIndoorDataCard',
              access: ['FEAT_SENSOR-DATA'],
              props: {
                showForEntityTypes: ['SPACE']
              }
            },
            {
              name: 'information',
              enabled: true,
              title: {
                en: 'Information',
                sv: 'Information'
              },
              component: 'InfoDisplayInformationCard',
              props: {
                showForEntityTypes: [
                  'COMPLEX',
                  'REAL_ESTATE',
                  'CONSTRUCTION',
                  'LEVEL',
                  'SPACE',
                  'POI',
                  'LINE',
                  'ZONE'
                ]
              }
            },
            {
              name: 'place',
              enabled: true,
              title: {
                en: 'Place',
                sv: 'Plats'
              },
              component: 'InfoDisplayPlaceCard',
              props: {
                showForEntityTypes: ['COMPLEX', 'REAL_ESTATE', 'CONSTRUCTION', 'POI', 'ZONE']
              }
            },
            {
              name: 'areas',
              enabled: true,
              title: {
                en: 'Areas',
                sv: 'Areor'
              },
              component: 'InfoDisplayAreasCard',
              props: {
                showForEntityTypes: [
                  'REGION',
                  'COMPLEX',
                  'REAL_ESTATE',
                  'CONSTRUCTION',
                  'LEVEL',
                  'SPACE',
                  'ZONE'
                ]
              }
            },
            {
              name: 'roomedit',
              enabled: false,
              title: {
                en: 'Edit room',
                sv: 'Uppdatera rum'
              },
              access: ['FEAT_CORE_ADMIN', 'FEAT_CORE_CREATOR', 'FEAT_CORE_EDITOR'],
              component: 'InfoDisplayRoomEdit',
              props: {
                showForEntityTypes: ['SPACE']
              }
            },
            {
              name: 'zones',
              enabled: true,
              title: {
                en: 'Zones',
                sv: 'Zoner'
              },
              component: 'InfoDisplayZoneSummaryCard',
              access: [
                'FEAT_ZONE_ADMIN',
                'FEAT_ZONE_CREATOR',
                'FEAT_ZONE_EDITOR',
                'FEAT_ZONE_READER'
              ],
              props: {
                showForEntityTypes: ['REAL_ESTATE', 'CONSTRUCTION', 'LEVEL']
              }
            },
            {
              name: 'Lines',
              enabled: true,
              title: {
                en: 'Lines',
                sv: 'Linjer'
              },
              component: 'InfoDisplayLineSummaryCard',
              access: [
                'FEAT_LINE_ADMIN',
                'FEAT_LINE_CREATOR',
                'FEAT_LINE_EDITOR',
                'FEAT_LINE_READER'
              ],
              props: {
                showForEntityTypes: ['REAL_ESTATE']
              }
            },
            {
              name: 'Pois',
              enabled: true,
              title: {
                en: 'Pois',
                sv: 'Intressepunkter'
              },
              component: 'InfoDisplayPoiSummaryCard',
              access: ['FEAT_POI_ADMIN', 'FEAT_POI_CREATOR', 'FEAT_POI_EDITOR', 'FEAT_POI_READER'],
              props: {
                showForEntityTypes: ['REAL_ESTATE', 'CONSTRUCTION', 'LEVEL']
              }
            }
          ]
        }
      ]
    }
  ]
}
